// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"0ae61e24","261":"a75a6b36"}[chunkId] + ".chunk.css";
};